

























import type { NuxtError } from '@nuxt/types';

interface ErrorLayoutThis {
  $router: { push: (route: { name: string }) => Promise<void> };
  $nuxt?: { context?: { app?: { localeRoute?: (opts: { name: string }) => { name: string } } } };
}

export default {
  props: {
    error: {
      type: Object as () => NuxtError,
      required: true,
    },
  },
  methods: {
    async goToStockList(this: ErrorLayoutThis) {
      const app = this.$nuxt?.context?.app;
      const route = app?.localeRoute?.({ name: 'stock-list' }) ?? { name: 'stock-list' };
      await this.$router.push(route);
    },
  },
};
